import React, { Component } from "react";
import { connect } from "react-redux";
import { Panel } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import Plot from "react-plotly.js";
import moment from "moment";
import { api } from "../../_services";

import "./index.css";

class DashboardRimgCounter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listLoading: true,
      listLoading2: true,
    };
  }

  componentDidMount = () => {
    this.getDashboardRIMG({
      ...(this.props.currentPrecinct && this.props.currentPrecinct.id && { "precinct": this.props.currentPrecinct.id }),
    });
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.currentPrecinct !== nextProps.currentPrecinct && nextProps.currentPrecinct) {
      this.getDashboardRIMG({
        ...(nextProps.currentPrecinct && nextProps.currentPrecinct.id && { "precinct": nextProps.currentPrecinct.id }),
      });
    } else if (this.props.reloadCount !== nextProps.reloadCount) {
      this.getDashboardRIMG({
        ...(this.props.currentPrecinct.id && { "precinct": this.props.currentPrecinct.id }),
      });
    }
  }

  /* Retrieve dashboard notes by precincts */
  getDashboardRIMG = p => {
    this.setState(() => {
      return {
        listLoading2: true,
      };
    });
    const url = "/api/v1/stats/rimg/";
    const params = {};
    if (p) {
      for (const key in p) {
        params[key] = p[key];
      }
    }
    const errorMsg = "Unable to retrieve dashboard RIMG.";
    api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
      this.setState(() => {
        return {
          data: json,
          listLoading: false,
          listLoading2: false,
        };
      });
    });
  };

  calculateColor = (item) => {
    const percentage = (item.rolling_alert_count / item.alert_day_threshold) * 100;
    if (percentage >= 90) {
      return "#f05151";
    } else if (percentage >= 50) {
      return "#ffa700";
    } else {
      return "#09d08a";
    }
  }

  textPosition = (item) => {
    const percentage = (item.rolling_alert_count / item.alert_day_threshold) * 100;
    if (percentage >= 20) {
      return "inside";
    } else {
      return "outside";
    }
  }

  renderChart = (name, item) => {

    const chartColor = this.calculateColor(item);
    const textPosition = this.textPosition(item);

    const chartData = [{
      type: "bar",
      x: [item.rolling_alert_count],
      name: name,
      orientation: "h",
      textposition: textPosition,
      text: item.rolling_alert_count,
      insidetextfont: {
        color: "#fff",
        size: 10,
      },
      outsidetextfont: {
        color: "#000",
        size: 10,
      },
      hoverinfo: "x",
      marker: {
        color: chartColor,
      },

    }];
    const chartConfig = {
      displaylogo: false,
      modeBarButtonsToRemove: [
        "zoom2d", "pan2d", "select2d", "lasso2d", "zoomIn2d", "zoomOut2d", "autoScale2d", "resetScale2d",
        "hoverClosestCartesian", "hoverCompareCartesian",
        "zoom3d", "pan3d", "resetCameraDefault3d", "resetCameraLastSave3d", "hoverClosest3d",
        "orbitRotation", "tableRotation",
        "zoomInGeo", "zoomOutGeo", "resetGeo", "hoverClosestGeo",
        "toImage",
        "sendDataToCloud",
        "hoverClosestGl2d",
        "hoverClosestPie",
        "toggleHover",
        "resetViews",
        "toggleSpikelines",
        "resetViewMapbox"
      ]
    };
    const chartLayout = {
      autosize: true,
      showlegend: false,
      margin: {
        l: 2,
        r: 10,
        b: 25,
        t: 10,
        pad: 0
      },
      xaxis: {
        tickfont: {
          size: 8
        },
        linecolor: "#868686",
        linewidth: 1,
        mirror: true,
        ticks: "outside",
        range: [0, item.alert_day_threshold]
      },
      yaxis: {
        title: "",
        tickfont: {
          size: 8,
          color: "#fff",
        },
        linecolor: "#868686",
        linewidth: 1,
        mirror: true,
      },
    };
    return (
      <Plot
        className="chartDiagram"
        data={chartData}
        layout={chartLayout}
        config={chartConfig}
        useResizeHandler={true}
      />
    );
  }

  renderCounter = (list, type) => {
    const counterList = list.map(function (item, index) {
      return (
        <div
          className="flex-col"
          key={index}
          title={item.name + ": " + moment(item[type].sample_period_start).format("ddd DD MMM YYYY")}
        >
          <div className="rimg-site-name">{item.name}</div>
          {this.renderChart(item.name, item[type])}
        </div>
      );
    }, this);
    if (counterList.length > 0) {
      return counterList;
    } else {
      return (
        <div
          className="flex-col"
        >
          <div className="title">No Data</div>
        </div>
      );
    }
  }

  render() {
    const { configList } = this.props;
    const { data, listLoading, listLoading2 } = this.state;
    if (!configList) {
      return null;
    }

    if (listLoading || !data) {
      return (
        <Panel className="panel-length dashboardRimgCounter">
          <div className="loading2" />
        </Panel>
      );
    }

    if (data && data.current.site_count === 0) {
      return null;
    }

    return (
      <Panel className="panel-length dashboardRimgCounter">
        <div className="panel-title">RIMG counter {listLoading2 && <FontAwesome className="loadingIcon" name="spinner" spin />}</div>
        <div className="panel-body">
          <div className="flex-row">
            <div className="flex-col title-col">
              <div className="title">Relocation (6 months)</div>
              {data.current.sites[0] &&
                <div className="subTitle">{moment(data.current.sites[0].long_term_relocation.sample_period_start).format("ddd DD MMM YYYY")} to today</div>
              }
            </div>
            <div className="flex-col">
              <div className="flex-row">
                {this.renderCounter(data.current.sites, "long_term_relocation")}
              </div>
            </div>
          </div>
          <div className="flex-row">
            <div className="flex-col title-col">
              <div className="title">Relocation (15 days)</div>
              {data.current.sites[0] &&
                <div className="subTitle">{moment(data.current.sites[0].short_term_relocation.sample_period_start).format("ddd DD MMM YYYY")} to today</div>
              }
            </div>
            <div className="flex-col">
              <div className="flex-row">
                {this.renderCounter(data.current.sites, "short_term_relocation")}
              </div>
            </div>
          </div>
          <div className="flex-row">
            <div className="flex-col title-col">
              <div className="title">Treatment (6 months)</div>
              {data.current.sites[0] &&
                <div className="subTitle">{moment(data.current.sites[0].long_term_treatment.sample_period_start).format("ddd DD MMM YYYY")} to today</div>
              }
            </div>
            <div className="flex-col">
              <div className="flex-row">
                {this.renderCounter(data.current.sites, "long_term_treatment")}
              </div>
            </div>
          </div>
        </div>
      </Panel >
    );
  }
}

function mapStateToProps(state) {
  const { configList } = state.configuration;
  const { user } = state.authentication;
  return {
    configList,
    user
  };
}

export default connect(mapStateToProps)(DashboardRimgCounter);



// WEBPACK FOOTER //
// ./src/_components/DashboardRimgCounter/index.js